import { useState, useEffect } from "react";

export function useNotificationPermission() {
  if (!("Notification" in window)) {
    // prevent crash in native app
    return null;
  }

  const [notificationPermission, setNotificationPermission] = useState(
    Notification.permission
  );

  useEffect(() => {
    if (!("permissions" in navigator)) {
      // fallback to window focus event if permissions api is not supported
      const onChange = () => {
        setNotificationPermission(Notification.permission);
      };

      window.addEventListener("focus", onChange);

      return () => {
        window.removeEventListener("focus", onChange);
      };
    }

    // subscribe to changes in the notification permission
    let _notificationPerm: PermissionStatus;
    navigator.permissions
      .query({ name: "notifications" })
      .then(function (notificationPerm) {
        _notificationPerm = notificationPerm;
        notificationPerm.onchange = () => {
          setNotificationPermission(
            mapPermissionStatusToNotificationPermission(notificationPerm.state)
          );
        };
      });

    return () => {
      if (_notificationPerm) _notificationPerm.onchange = null;
    };
  }, []);

  return notificationPermission;
}
function mapPermissionStatusToNotificationPermission(
  status: PermissionState
): NotificationPermission {
  switch (status) {
    case "granted":
      return "granted";
    case "denied":
      return "denied";
    case "prompt":
      return "default";
  }
}
